/**
 * Skeleton do Radar — header + seletor de período + KPIs + painéis.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-5xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Seletor de período */}
      <div className="h-9 w-64 rounded-xl bg-slate-100" />

      {/* KPIs */}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-[86px] rounded-xl border border-slate-200 bg-white p-4">
            <div className="h-3 w-16 rounded bg-slate-100" />
            <div className="mt-2 h-6 w-12 rounded bg-slate-200" />
          </div>
        ))}
      </div>

      {/* Painéis */}
      <div className="grid gap-4 md:grid-cols-2">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-[200px] rounded-xl border border-slate-200 bg-white p-4">
            <div className="h-4 w-40 rounded bg-slate-200" />
            <div className="mt-2 h-3 w-52 rounded bg-slate-100" />
            <div className="mt-6 h-28 rounded bg-slate-50" />
          </div>
        ))}
      </div>
    </div>
  );
}
